import React from 'react';
import { Item } from './styles';
import { formatTimestamp, formatValue, scaleValue } from './utils';

export default function WaterLevel({ data }) {
  if (!data) return null;

  return (
    <Item>
      <h3 style={{ marginBlockEnd: 0 }}>Water level</h3>
      {Object.entries(data).map(([sensor_id, d]) => {
        const waterLevelBatterySide = d.water_level_battery_side && scaleValue(d.water_level_battery_side, [20, 2700], [0, 54]);
        const waterLevelMotorSide = d.water_level_motor_side && scaleValue(d.water_level_motor_side, [20, 2700], [0, 54]);
        const depth = d.voltage && 0.162 * Math.exp(2.55 * d.voltage) - 0.162;
        return (
          <div key={d.id || d.timestamp}>
            {formatTimestamp(d.timestamp)}
            <p style={{ marginLeft: '1em' }}>
              {waterLevelBatterySide && <>Battery: ${formatValue(waterLevelBatterySide, 0)} mm<br /></> }
              {waterLevelMotorSide && <>Motor: ${formatValue(waterLevelMotorSide, 0)} mm<br /></> }
              {depth && <>Depth: {formatValue(depth, 0)} mm</>}
            </p>
          </div>
        );
      })}
    </Item>
  );
}
